import * as React from "react";
import { Box, Flex, Icon, LightMode, Tooltip } from "@chakra-ui/react";

type Props = {
  isTooltipOpen: boolean;
};

export function MapDropPin({ isTooltipOpen }: Props) {
  return (
    <Flex
      position="absolute"
      left={0}
      right={0}
      bottom={0}
      top={0}
      pointerEvents="none"
      alignItems="center"
      justifyContent="center">
      <LightMode>
        <Tooltip
          label="Move pin to your address"
          hasArrow
          placement="top"
          isOpen={isTooltipOpen}
          closeDelay={300}>
          <Box
            as="span"
            position="relative"
            top="-18px"
            height="36px"
            width="21px">
            <Icon viewBox="0 0 28 48" w="100%" h="100%">
              <circle
                cx="14"
                cy="14"
                r="11"
                fill="white"
                stroke="black"
                strokeWidth="6"
              />
              <mask id="path-2-inside-1_488_1068" fill="white">
                <rect x="11" y="23" width="6" height="25" rx="2" />
              </mask>
              <rect
                x="11"
                y="23"
                width="6"
                height="25"
                rx="2"
                fill="white"
                stroke="black"
                strokeWidth="5"
                mask="url(#path-2-inside-1_488_1068)"
              />
            </Icon>
          </Box>
        </Tooltip>
      </LightMode>
    </Flex>
  );
}
